import { render } from "./SignaturePopupView.vue?vue&type=template&id=2c2046fd&scoped=true"
import script from "./SignaturePopupView.vue?vue&type=script&lang=js"
export * from "./SignaturePopupView.vue?vue&type=script&lang=js"

import "./SignaturePopupView.vue?vue&type=style&index=0&id=2c2046fd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2046fd"]])

export default __exports__